import { defineStore } from 'pinia';
import UINotification from './entity/UINotification';
import UIDialog from './entity/UIDialog';
import { IUIstate, TActions, TNotification, TUIDialog } from '@/types';

const state: IUIstate = {
    mainLoader: false,
    ringLoader: false,
    notifications: [],
    dialog: null,
    innerHeight: 0,
    innerWidth: 0,
    action: null,
    wsOnline: false,
};

export const useUI = defineStore('ui', {

    state: () => (state),

    getters: {
        allNotifications(): UINotification[] {
            return this.notifications;
        },
        getDialog(): UIDialog | null
        {
            return this.dialog;
        }
    },

    actions: {
        setNotification(type: TNotification, message: string, key: string | null): void
        {
            if (!this.notifications.some((item: UINotification) => item.key === key) || !key) {
                this.notifications.push(new UINotification(type, message, key));
            }
        },
        deleteNotification(key = null) {
            this.notifications = this.notifications.filter(item => item.key !== key);
        },
        clearNotifications() {
            this.notifications = [];
        },

        setDialog(
            title: string,
            callBack: any,
            type?: TUIDialog,
            initData?: any,
            message?: string, 
            okButton?: string,
            cancelButton?: string
        ) {
            /*
                if type === 'radio' ? initData = [{value: 'test1', checked: false, text: 'test 1'}]
                if type === 'users' ? initData = {allow: new Set(), locked: new Set()}
            */
            this.dialog = new UIDialog(title, callBack, type, initData, message, okButton, cancelButton);
        },

        deleteDialog() {
            this.dialog = null;
        },

        setAction(payload: TActions) {
            this.action = payload;
        }
    }

});